<template>
<div>
  <notification :notification="notification" @dismissAlert="dismiss"></notification>
  <form role="form" class="elr-form elr-container" @submit.prevent="update" id="update-year">
    <ul v-show="errors.length">
        <li :key="e" v-for="e in errors">
            <span :key="value" v-for="(key, value) in e">{{value}}: {{key[0]}}</span>
        </li>
    </ul>
    <div class="elr-row">
        <div class="elr-col-full">
            <input type="text" placeholder="Year Made" name="year_made" v-model="formData.year_made">
        </div>
    </div>
    <div class="elr-row">
        <div class="elr-col-full">
            <input type="text" placeholder="Year Name" name="year_name" v-model="formData.year_name">
        </div>
    </div>
    <div class="elr-row">
        <div class="elr-col-full">
            <textarea cols="30" rows="10" name="description" v-model="formData.description" placeholder="Description"></textarea>
        </div>
    </div>
    <div class="elr-row">
        <div class="elr-col-full form-input-holder">
            <button type="submit" class="elr-button elr-button-primary">Update Year</button>
        </div>
    </div>
  </form>
</div>
</template>

<script>
import axios from 'axios';
import Notification from '../Notification/Notification';

export default {
  name: 'FormYearEdit',
  props: {
    yearMade: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      errors: [],
      year: {},
      formData: {
        year_name: null,
        year_made: null,
        description: null
      },
      notification: {
        show: false,
        message: '',
        className: ''
      }
    };
  },
  components: {
    Notification
  },
  mounted() {
    axios.get(`${process.env.VUE_APP_ROOT_API}/year/${this.yearMade}`).then(response => {
      this.year = response.data.year;
      this.formData = response.data.year;
    });
  },
  methods: {
    dismiss() {
      this.notification.show = false;
    },
    update() {
      axios
        .put(`${process.env.VUE_APP_ROOT_API}/year/${this.yearMade}`, this.formData)
        .then(({ data }) => {
          this.errors = [];

          if (data.item) {
            this.$emit('yearUpdated', data.item);
            this.notification.show = true;
            this.notification.message = 'Year updated successfully';
            this.notification.className = 'elr-alert-success';
          } else {
            this.resetForm();
            this.notification.show = true;
            this.notification.message =
              'There was problem a updating your year';
            this.notification.className = 'elr-alert-danger';
            this.errors.push({
              error: ['Please try to update years later']
            });
          }
        })
        .catch(e => {
          this.errors = [];

          if (e.response) {
            this.notification.show = true;
            this.notification.message =
              'There was a problem updating your year';
            this.notification.className = 'elr-alert-danger';
            this.errors.push(e.response.data.errors);
          }
        });
    }
  }
};
</script>
